import React, { useEffect, useRef } from 'react';
import Grid from '@mui/material/Grid';
import hero from '../../images/hero.png';
import { Box } from '@mui/system';
import { Button, Link, Typography } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import EmailIcon from '@mui/icons-material/Email';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import { init } from 'ityped';
import './Banner.css'
// import Particles from "react-tsparticles";
import resume from '../../images/Akramul_Software_Engineer.pdf';


const Banner = () => {
    const textRef = useRef();

    useEffect(() => {
        init(textRef.current, {
            showCursor: true,
            typeSpeed: 180,
            backDelay: 2000,
            backSpeed: 150,
            cursorChar: "!",
            strings: ['Full Stack Developer', 'MERN Stack Developer', 'Frontend Developer', 'React Developer', 'Software Engineer']
        })
    }, []);

    // const particlesInit = (main) => {
    //     console.log(main);

    //     // you can initialize the tsParticles instance (main) here, adding custom shapes or presets
    // };

    // const particlesLoaded = (container) => {
    //     console.log(container);
    // };


    useEffect(() => {
        setTimeout(() => {
            (function () {
                var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
                    window.setTimeout(callback, 1000 / 60);
                };
                window.requestAnimationFrame = requestAnimationFrame;
            })();

            // Terrain stuff.
            var background = document.getElementById("bgCanvas"),
                bgCtx = background.getContext("2d"),
                width = window.innerWidth,
                // height = document.body.offsetHeight;
                height = 450;

            // (height < 400) && height = 400;

            background.width = width;
            background.height = height;

            function Terrain(options) {
                options = options || {};
                this.terrain = document.createElement("canvas");
                this.terCtx = this.terrain.getContext("2d");
                this.scrollDelay = options.scrollDelay || 90;
                this.lastScroll = new Date().getTime();

                this.terrain.width = width;
                this.terrain.height = height;
                this.fillStyle = options.fillStyle || "#7f8c8d";
                // this.fillStyle = options.fillStyle || "#2D3436";
                this.mHeight = options.mHeight || height;

                // generate
                this.points = [];

                var displacement = options.displacement || 140,
                    power = Math.pow(2, Math.ceil(Math.log(width) / (Math.log(2))));

                // set the start height and end height for the terrain
                this.points[0] = this.mHeight;//(this.mHeight - (Math.random() * this.mHeight / 2)) - displacement;
                this.points[power] = this.points[0];

                // create the rest of the points
                for (var i = 1; i < power; i *= 2) {
                    for (var j = (power / i) / 2; j < power; j += power / i) {
                        this.points[j] = ((this.points[j - (power / i) / 2] + this.points[j + (power / i) / 2]) / 2) + Math.floor(Math.random() * -displacement + displacement);
                    }
                    displacement *= 0.6;
                }

                document.body.appendChild(this.terrain);
            }

            Terrain.prototype.update = function () {
                // draw the terrain
                this.terCtx.clearRect(0, 0, width, height);
                this.terCtx.fillStyle = this.fillStyle;

                if (new Date().getTime() > this.lastScroll + this.scrollDelay) {
                    this.lastScroll = new Date().getTime();
                    this.points.push(this.points.shift());
                }

                this.terCtx.beginPath();
                for (var i = 0; i <= width; i++) {
                    if (i === 0) {
                        this.terCtx.moveTo(0, this.points[0]);
                    } else if (this.points[i] !== undefined) {
                        this.terCtx.lineTo(i, this.points[i]);
                    }
                }

                this.terCtx.lineTo(width, this.terrain.height);
                this.terCtx.lineTo(0, this.terrain.height);
                this.terCtx.lineTo(0, this.points[0]);
                this.terCtx.fill();
            }


            // Second canvas used for the stars
            bgCtx.fillStyle = '#05004c';
            bgCtx.fillStyle = '#212529';
            bgCtx.fillRect(0, 0, width, height);


            var entities = [];


            entities.push(new Terrain({ mHeight: (height / 2) - 120 }));
            entities.push(new Terrain({ displacement: 120, scrollDelay: 50, fillStyle: "rgb(149, 165, 166)", mHeight: (height / 2) - 60 }));
            entities.push(new Terrain({ displacement: 100, scrollDelay: 20, fillStyle: "rgb(45, 52, 54)", mHeight: height / 2 }));

            //animate background
            function animate() {
                bgCtx.fillStyle = '#F5F6F7';
                bgCtx.fillRect(0, 0, width, height);
                bgCtx.fillStyle = '#ffffff';
                bgCtx.strokeStyle = '#2D3436';

                var entLen = entities.length;

                while (entLen--) {
                    entities[entLen].update();
                }
                requestAnimationFrame(animate);
            }
            animate();
        }, 2100);
    }, []);



    return (
        <Box id="intro" sx={{ flexGrow: 1, py: '10px' }}>
            <canvas id='bgCanvas' />

            {/* <Particles
                id="tsparticles"
                init={particlesInit}
                loaded={particlesLoaded}
                options={{

                    fpsLimit: 30,
                    interactivity: {
                        events: {
                            onClick: {
                                enable: true,
                                mode: "push",
                            },
                            onHover: {
                                enable: false,
                                mode: "repulse",
                            },
                            resize: true,
                        },
                        modes: {
                            bubble: {
                                distance: 400,
                                duration: 2,
                                opacity: 0.8,
                                size: 40,
                            },
                            push: {
                                quantity: 4,
                            },
                            repulse: {
                                distance: 100,
                                duration: 0.4,
                            },
                        },
                    },
                    particles: {
                        color: {
                            value: "#ffffff",
                        },
                        links: {
                            color: "#fff",
                            distance: 150,
                            enable: true,
                            opacity: 0.1,
                            width: 1,
                        },
                        collisions: {
                            enable: true,
                        },
                        move: {
                            direction: "none",
                            enable: true,
                            outMode: "bounce",
                            random: false,
                            speed: 3,
                            straight: false,
                        },
                        number: {
                            density: {
                                enable: true,
                                value_area: 1000,
                            },
                            value: 80,
                        },
                        opacity: {
                            value: 0.1,
                        },
                        shape: {
                            type: "circle",
                        },
                        size: {
                            random: true,
                            value: 3,
                        },
                    },
                    detectRetina: true,
                }}
            /> */}

            <Grid sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', zIndex: 10 }} container spacing={{ xs: 2, md: 3 }} columns={{ xs: 6, sm: 6, md: 12 }}>
                <Grid sx={{ color: 'gray', px: { xs: '10px', md: 0 }, mt: { xs: '100px', md: '100px' }, textAlign: { xs: 'center', md: 'center' }, }} item xs={12} sm={12} md={6}>
                    <Typography sx={{ fontWeight: 'bold', letterSpacing: '1.5px', color: 'rgba(255, 255, 255, 0.689)' }} variant="h6" gutterBottom component="div">
                        Hi! I'm Md. Akramul Hoque
                    </Typography>
                    <Typography sx={{ fontWeight: '700', color: '#ffffffeb' }} variant="h6" gutterBottom component="div">
                        <span className="ityped-cursor" ref={textRef}></span>
                    </Typography>


                    <Grid sx={{ ml: { xs: '70px', md: '150px' } }} container>
                        <Grid item>
                            <HomeIcon sx={{ fontSize: '20px', color: '#ffffffeb' }} />
                        </Grid>
                        <Grid item sx={{ mx: '5px' }}>
                            <Typography sx={{ color: '#ffffffeb' }} variant="p">Address:</Typography>
                            <Typography sx={{ ml: '20px', letterSpacing: '1.5px', color: 'rgba(255, 255, 255, 0.689)' }} variant="p">Dhaka, Bangladesh</Typography>
                        </Grid>
                    </Grid>

                    <Grid sx={{ ml: { xs: '70px', md: '150px' } }} container>
                        <Grid item>
                            <EmailIcon sx={{ fontSize: '20px', color: '#ffffffeb' }} />
                        </Grid>

                        <Grid item sx={{ mx: '5px' }}>
                            <Typography sx={{ color: '#ffffffeb' }} variant="p">Email:</Typography>

                            <Link href="mailto:ictianlikhon6@gmail.com" underline="none">
                                <Typography sx={{ ml: '20px', color: 'rgba(255, 255, 255, 0.689)', letterSpacing: '1.5px' }} variant="p">ictianlikhon6@gmail.com</Typography>
                            </Link>
                        </Grid>
                    </Grid>

                    <Grid sx={{ ml: { xs: '70px', md: '150px' } }} container>
                        <Grid item>
                            <ContactPhoneIcon sx={{ fontSize: '18px', color: '#ffffffeb' }} />
                        </Grid>

                        <Grid item sx={{ mx: '5px' }}>
                            <Typography sx={{ color: '#ffffffeb' }} variant="p">Phone:</Typography>
                            <Link href="callto:01639076632" underline="none">
                                <Typography sx={{ ml: '20px', color: 'rgba(255, 255, 255, 0.689)', letterSpacing: '1.5px' }} variant="p">01639076632</Typography>
                            </Link>
                        </Grid>
                    </Grid>

                    <Grid container sx={{ mt: 2, ml: { xs: '90px', md: '150px' } }}>
                        <Link sx={{ textDecoration: 'none' }} href="#about-me" undeline="none">
                            <Button variant="contained" style={{ marginRight: '10px', backgroundColor: '#1976d200', border: '1px solid #FFFFFF4E', color: 'rgba(255, 255, 255, 0.689)', fontWeight: 'bold', letterSpacing: '1.5px' }}>About Me</Button>
                        </Link>

                        <Link sx={{ textDecoration: 'none' }} href={resume} target="_blank" undeline="none">
                            <Button style={{ backgroundColor: '#1976d200', border: '1px solid #FFFFFF4E', color: 'rgba(255, 255, 255, 0.689)', fontWeight: 'bold', letterSpacing: '1.5px' }} variant="contained">Get Resume</Button>
                        </Link>
                    </Grid>

                </Grid>
                <Grid sx={{ mt: { xs: '20px', md: '90px' }, ml: { xs: '40px', md: '0px' }, textAlign: { xs: 'left', md: 'left' } }} item xs={12} sm={12} md={6}>

                    <img style={{ width: '70%', marginLeft: '40px' }} src={hero} alt="me"></img>

                </Grid>
            </Grid>
        </Box>
    );
};

export default Banner;